import { Col, Link } from '@policygenius/mortar';
import React from 'react';
import FeedbackTitleContent from './FeedbackTitleContent';
import { Container, FeedbackBody } from './styles';

const FeedbackContainer = () => {
  return (
    <Container fullWidth>
      <Col>
        <FeedbackTitleContent />
        <FeedbackBody>
          We&apos;d love to hear from you! Email us at&nbsp;
          <Link href="mailto:pgproaccounts@policygenius.com" size="large">
            pgproaccounts@policygenius.com
          </Link>
        </FeedbackBody>
      </Col>
    </Container>
  );
};

export default FeedbackContainer;
